module.exports = __webpack_public_path__ + "static/media/re_bg2.8d580258.png";